module.exports = __webpack_public_path__ + "static/NudistaThin-Italic-a05bcfd71d96543313a3a2180562a6e9.ttf";